import tracking from 'dibs-tracking';
import { sessionStorage } from 'dibs-browser-storage';

const STORAGE_KEY = 'confirmMessageDesignerConnectionType';

export const CONFIRMATION_TYPE_CONTACT = 'contact dealer confirmation';
export const CONFIRMATION_TYPE_FOLDER = 'folder confirmation';

export function setDesignerConnectionMessageShown(confirmationType) {
    sessionStorage.setItem(STORAGE_KEY, confirmationType);
}

export function trackCtaClick(confirmationType) {
    tracking.trackEvent({
        category: 'design features',
        action: 'confirmation modal',
        label: `try designer matchmaker clicked|${confirmationType}`,
    });
}

export function trackDesignerConnectionMessageClose() {
    const confirmationType = sessionStorage.getItem(STORAGE_KEY);
    if (confirmationType) {
        tracking.trackEvent({
            category: 'design features',
            action: 'confirmation modal',
            label: `close modal clicked|${confirmationType}`,
        });
        sessionStorage.deleteItem(STORAGE_KEY);
    }
}

export function trackDesignerConnectionPostConfirmationModalReferer() {
    const confirmationType = sessionStorage.getItem(STORAGE_KEY);
    if (confirmationType) {
        tracking.trackEvent({
            category: 'design features',
            action: 'designer connection',
            label: `form entry|${confirmationType}`,
        });
        sessionStorage.deleteItem(STORAGE_KEY);
    }
}
